module.exports = __webpack_public_path__ + "static/scale-model-of-visit-baton-rouge-in-baton-rouge-louisiana-2250f5a7f95637964a2a9eb261876b95.png";